// src/components/EmotionWheel.js
import React from 'react';
import './EmotionWheel.css';

function EmotionWheel({ emotions, onSelectEmotion, disabled }) {
  if (!emotions || emotions.length === 0) {
    return <p>Загрузка списка эмоций...</p>;
  }

  if (emotions.length !== 14) {
    console.warn(`EmotionWheel: Ожидается 14 эмоций для заданного расположения, получено ${emotions.length}. Отображение списком.`);
    return (
      <div className="emotion-list-fallback" style={{display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center'}}>
        {emotions.map(emotion => (
          <button
            key={emotion.emotion_id}
            onClick={() => onSelectEmotion(emotion.emotion_id)}
            disabled={disabled}
            title={emotion.emotion_name_ru}
            className="emotion-button-on-wheel"
          >
            {emotion.emotion_name_ru}
          </button>
        ))}
      </div>
    );
  }

 const containerSize = 450;  // Размер контейнера (ширина и высота)

  const radius = containerSize * 0.45;
  const centerX = containerSize / 2;
  const centerY = containerSize / 2;

  // Вертикальное распределение 7 уровней
  const itemsPerColumn = 7;
  const topPadding = containerSize * 0.064;   // ~35px при размере 550px
  const bottomPadding = containerSize * 0.064; // симметричная нижняя отступ
  const usableVerticalSpace = containerSize - topPadding - bottomPadding;
  const verticalStep = usableVerticalSpace / (itemsPerColumn - 1); // 6 промежутков между 7 элементами

  return (
    <div className="emotion-wheel-container" style={{ width: `${containerSize}px`, height: `${containerSize}px` }}>
      <div className="emotion-wheel" style={{ width: '100%', height: '100%' }}>
        {emotions.map((emotion, index) => {
          let x, y;
          
          const isRightColumn = index < itemsPerColumn; // Эмоции 0-6 для правой колонки
          const itemLevel = index % itemsPerColumn;   // Уровень от 0 (верхний) до 6 (нижний)

          y = topPadding + itemLevel * verticalStep;

           // Рассчитываем X-координату из уравнения окружности
          const xOffset = Math.sqrt(Math.max(0, radius ** 2 - (y - centerY) ** 2));
          x = isRightColumn ? centerX + xOffset : centerX - xOffset;
          
          return (
            <button
              key={emotion.emotion_id}
              className="emotion-button-on-wheel"
              style={{
                position: 'absolute',
                left: `${x}px`,
                top: `${y}px`,
                transform: 'translate(-50%, -50%)',
              }}
              onClick={() => onSelectEmotion(emotion.emotion_id)}
              disabled={disabled}
              title={emotion.emotion_name_ru}
            >
              {emotion.emotion_name_ru}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default EmotionWheel;